export default function (target, type) {
  return typeof target === type;
}
